import MediaQuery from 'react-responsive';
import Grid from '../components/grid';
import Carousel from '../components/carousel';
import Key3 from '../components/keys/key3';
import Key2Mobile from '../components/keys/key2mobile';

function FindAPLace({animate}) {
   return(
      <div className="flex find-a-place mobile-reverse-order ">
         <MediaQuery maxWidth={767}>
            <Key2Mobile  animate={animate}/>
         </MediaQuery>
         <div className="col-1/2 px-15">
            <h2>Find a place to call home</h2>
            <p>It’s time to explore our developments to find your perfect place. Buying a brand-new home opens a world of opportunity. Whether you’re dreaming of a new kitchen to bake in, a dedicated space to work or a garden to entertain friends and family, there is a wide range to choose from and all are a blank canvas for you to create your perfect home.</p>
            <a href="/" className="btn btn-primary">Find my home</a>
         </div>
         <div className="col-1/2">
            <MediaQuery maxWidth={767}>
               <Carousel/>
            </MediaQuery>
            <MediaQuery minWidth={768}>
               <Grid/>
            </MediaQuery>
         </div>
         <MediaQuery minWidth={768}>
            <Key3  animate={animate}/>
         </MediaQuery>

      </div>
   )
}

export default FindAPLace;